import { Component } from "react"
import PropTypes from "prop-types"
import { FACTOR } from "../../shapes"
import "./style.scss"
import SortIcon from "components/sort-icon"

class FactorHeader extends Component {
  onClick = () => {
    const { factor: { type, id }, setSort } = this.props
    setSort(type, id)
  }

  render() {
    const { factor: { label, sort } } = this.props
    const className = sort ? `sorted ${sort}` : ""

    return <th className={className} onClick={this.onClick}>{sort ? <SortIcon direction={sort} /> : <span className="no-sort-icon" /> }{label}</th>
  }
}

function FactorHeaders({ factors, setSort }) {
  return <tr className="factor-headers">
    <th />
    {factors.map(factor => <FactorHeader key={factor.id} {...{ factor, setSort }} />)}
  </tr>
}

FactorHeader.propTypes = {
  factor: FACTOR.isRequired,
  setSort: PropTypes.func.isRequired,
}

FactorHeaders.propTypes = {
  factors: PropTypes.arrayOf(FACTOR).isRequired,
  setSort: PropTypes.func.isRequired,
}

export default FactorHeaders
